import PublicAppealsWidget from './component'

export default PublicAppealsWidget
